import PreviewIcon from "@mui/icons-material/Preview";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";
export const AttachmentsList = ({
	attachments,
	selectedAttachment,
	setSelectedAttachment,
}) => {
	return (
		<Box
			sx={{
				p: "30px",
				display: "flex",
				flexDirection: "column",
				gap: "10px",
			}}
		>
			<Typography
				variant="h4"
				component="h2"
				sx={{ textAlign: "center", mb: "20px" }}
			>
				Wybierz załącznik do analizy AI
			</Typography>
			{attachments?.map((attachment) => (
				<>
					{attachment.contentType.includes("image") && (
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								cursor: "pointer",
								p: "10px",
								border: (theme) =>
									selectedAttachment === attachment.name
										? `2px solid ${theme.palette.primary.main}`
										: "1px solid #999",
							}}
							key={attachment.name}
							onClick={() => setSelectedAttachment(attachment.name)}
						>
							<span>{attachment.name}</span>
							<AttachmentPreview attachment={attachment} />
						</Box>
					)}
					{!attachment.contentType.includes("image") && (
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								cursor: "pointer",
								p: "10px",
								border: (theme) =>
									selectedAttachment === attachment.name
										? `2px solid ${theme.palette.primary.main}`
										: "1px solid #999",
							}}
						>
							<span>{attachment.name}</span>
							<Tooltip
								title={
									<Typography
										variant="p"
										sx={{ fontSize: "9pt" }}
										component="span"
									>
										Nieobsługiwany typ pliku
									</Typography>
								}
							>
								<WarningAmberIcon color="error" />
							</Tooltip>
						</Box>
					)}
				</>
			))}
		</Box>
	);
};

const AttachmentPreview = ({ attachment }) => {
	const blob = new Blob(
		[Uint8Array.from(atob(attachment?.content), (c) => c.charCodeAt(0))],
		{ type: attachment?.contentType }
	);
	const url = URL.createObjectURL(blob);

	return (
		<Tooltip
			// disableInteractive
			// enterDelay={300}
			// leaveDelay={100}
			// open={true}
			// placement="top"
			title={
				<Box sx={{ width: "320px" }}>
					<img
						// src="https://images.pexels.com/photos/31416365/pexels-photo-31416365/free-photo-of-oszalamiajacy-pejzaz-miejski-tokio-o-zmierzchu.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
						src={url}
						alt=""
						style={{ width: "100%" }}
					/>
				</Box>
			}
			slotProps={{
				tooltip: {
					sx: {
						maxWidth: "400px",
						width: "100%",
						p: "3px 0 0 3px",
					},
				},
				// popper: {
				// 	modifiers: [
				// 		{
				// 			name: "preventOverflow",
				// 			options: {
				// 				boundary: "viewport", // or "window"
				// 			},
				// 		},
				// 	],
				// },
			}}
		>
			<PreviewIcon sx={{ color: (theme) => theme.palette.primary.main }} />
		</Tooltip>
	);
};
